// extracted by mini-css-extract-plugin
export var checkbox = "Checkbox-module--checkbox--2mZlv";
export var icon = "Checkbox-module--icon--2Dqun";
export var text = "Checkbox-module--text--1swnQ";
export var background = "Checkbox-module--background--1XRPT";
export var error = "Checkbox-module--error--3vFPw";